import React from "react";
import "../App.css";
import "./HowItWorks.css";

import { MdFlightLand } from "react-icons/md";
import { MdTravelExplore } from "react-icons/md";

import { MdFlight } from "react-icons/md";
import { FaCloudDownloadAlt } from "react-icons/fa";

export default function HowItWorks() {
  return (
    <div className="container">
      <div className="row my-5">
        <div className="col-md-12 mb-3">
          <h2
            className="text-center"
            style={{
              color: "#063970",
              fontWeight: "bold",
              fontFamily: "Oswald, sans-serif",
            }}
          >
            How it works
          </h2>
        </div>
        <div className="col-md-4 mb-3">
          <div className="p-4 border rounded h-100 ">
            <div className="mb-2 text-center ">
              <MdFlight size={60} color="#063970" />
            </div>
            <h5 className="text-center">Measure your carbon footprint</h5>

            <p>
              {" "}
              <MdFlightLand
                size={20}
                color="#063970"
                className="carbon-icon"
              />{" "}
              Our tools Calculated your flight emissions accurately
            </p>
            <p>
              {" "}
              <MdFlightLand
                size={20}
                className="carbon-icon"
                color="#063970"
              />{" "}
              Enter Your Flying Hours
            </p>
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <div className="p-4 border rounded h-100">
            <div className="mb-2 text-center ">
              <FaCloudDownloadAlt size={60} color="#063970" />
            </div>
            <h5 className="text-center">Offset Your Emissions</h5>
            <p>
              <MdFlightLand size={20} color="#063970" className="carbon-icon" />{" "}
              GIS have Selected from two High impact,verified Carbon offset
              projects
            </p>
            <p>
              {" "}
              <MdFlightLand
                size={20}
                color="#063970"
                className="carbon-icon"
              />{" "}
              instantly neturalize your travel footprint
            </p>
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <div className="p-4 border rounded h-100">
            <div className="mb-2 text-center ">
              <MdTravelExplore size={60} color="#063970" />
            </div>
            <h5 className="text-center">Travel Responsibly</h5>
            <p>
              <MdFlightLand size={20} color="#063970" className="carbon-icon" />{" "}
              Receive a certificate conforming your carbon-neutral travel
            </p>
            <p>
              <MdFlightLand size={20} color="#063970" className="carbon-icon" />{" "}
              Support sustainabilty while Traveling
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
